import moment from 'moment';
import React from 'react';

interface TimeLabelProps {
  fallback?: string;
  value?: string;
  skipUtc: boolean;
}

class TimeLabel extends React.PureComponent<TimeLabelProps> {
  render() {
    const { skipUtc, value } = this.props;

    if (value) {
      const time = skipUtc ? moment(value) : moment.utc(value);

      return <span>{time.format('h:mm a')}</span>;
    }

    return <span>{this.props.fallback}</span>;
  }
}

export default TimeLabel;
